import { Box } from '@mui/material';
import { isEmpty } from 'lodash-es';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { ShepherdTour } from 'react-shepherd';
import { Spinner } from 'wisestep-base';

import { tourOptions, jobcrmSteps } from '../../utils/TourStepsAndOptions';
import useJob from '../jobs/hooks/useJob';
import JobPageParams from '../jobs/types/JobPageParams';
import UserProfileOverview from '../recruiterProfileDetails/components/userProfile/UserProfileOverview';
import { TaskDefaultQuery } from '../tasks/TaskDefaultQuery';

import HeaderBanner from './components/headerBanner';
import { JobsCrm } from './components/helper/JobsCrmHelper';
import { useCandidateStats } from './components/helper/JobsStatsHook';
import JobsCrmInsights from './insights';
import JobsCrmPipeline from './pipeline';
import JobCrmReminders from './reminders';
import Layout from './similarJobs';
import JobsCrmSmartSource from './smartSource';

const JobsCrmListing = () => {
  const params = useParams<JobPageParams>();
  const jobId = params.jobId ?? '';
  const encodedEmail = params.encodedEmail ?? '';

  const [job, isLoading] = useJob(jobId);
  const jobStats = useCandidateStats(jobId);
  const [pageType, setPageType] = useState(params.type ?? JobsCrm.SMART_SOURCE);
  const jobsCrmType = {
    [JobsCrm.SMART_SOURCE]: () => {
      setPageType(JobsCrm.SMART_SOURCE);
      window.history.pushState(null, ``, `/jobs-crm/${jobId}/false/0/smartSource`);
    },
    [JobsCrm.INSIGHTS]: () => {
      setPageType(JobsCrm.INSIGHTS);
      window.history.pushState(null, ``, `/jobs-crm/${jobId}/candidate-analytics`);
    },
    [JobsCrm.PIPELINE]: () => {
      setPageType(JobsCrm.PIPELINE);
      !isEmpty(encodedEmail)
        ? window.history.pushState(null, ``, `/jobs-crm/${jobId}/false/0/pipeline/${encodedEmail}`)
        : window.history.pushState(null, ``, `/jobs-crm/${jobId}/false/0/pipeline`);
    },
    [JobsCrm.TASKS]: () => {
      setPageType(JobsCrm.TASKS);
      window.history.pushState(null, ``, `/jobs-crm/${jobId}/false/0/tasks`);
    },
    [JobsCrm.SIMILAR_JOBS]: () => {
      setPageType(JobsCrm.SIMILAR_JOBS);
      window.history.pushState(null, ``, `/jobs-crm/${jobId}/false/0/similarJobs`);
    },
    [JobsCrm.JOB_ANALYTICS]: () => {
      setPageType(JobsCrm.JOB_ANALYTICS);
      window.history.pushState(null, ``, `/jobs-crm/${jobId}/job-analytics`);
    },
  };

  return (
    <>
      {isLoading && <Spinner />}
      {job && !isLoading && (
        <Box>
          <ShepherdTour steps={jobcrmSteps} tourOptions={tourOptions}>
            <HeaderBanner job={job} jobsCrmType={(type: string) => jobsCrmType[type]?.()} />
            {pageType === JobsCrm.SMART_SOURCE && (
              <JobsCrmSmartSource job={job} index={Number(params.defaultJDTab)} />
            )}
            {pageType === JobsCrm.INSIGHTS && <JobsCrmInsights />}
            {pageType === JobsCrm.PIPELINE && (
              <JobsCrmPipeline
                job={job}
                candidateEmail={encodedEmail}
                index={Number(params.defaultJDTab)}
                jobStats={jobStats[0]}
              />
            )}
            {pageType === JobsCrm.TASKS && (
              <JobCrmReminders
                customQuery={{
                  ...TaskDefaultQuery,
                  taskAttributes: { jobCode: [job.jobCode ?? ''] },
                }}
              />
            )}
            {pageType === JobsCrm.SIMILAR_JOBS && <Layout job={job} />}
            {pageType === JobsCrm.JOB_ANALYTICS && (
              <UserProfileOverview jobId={job.id} jobPostedOn={job.createdOn} />
            )}
          </ShepherdTour>
        </Box>
      )}
    </>
  );
};
export default JobsCrmListing;
